import { getCategoryHref } from '../../utils/common/category';
import { SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'sideHustleIdeaGeneratorType',
      analyticsName: 'side_hustle_idea_type',
      textLabel: 'Generate side hustle ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Side hustle',
        value: getCategoryHref(SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'sideHustleIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'side_hustle_ideas_generator',
      placeholder: 'Try "product design" or "playing tennis"',
      textLabel: 'Describe your strengths',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
